import { OpenAPI } from '../../../openapi/core/OpenAPI'
import { request as __request } from '../../../openapi/core/request'

export interface LinkedInTargetSummary {
  id: string
  name: string
  vanityName?: string
  avatarUrl?: string
}

export interface LinkedInTargetsResponse {
  personal?: LinkedInTargetSummary
  organizations: LinkedInTargetSummary[]
  selected?: { type: 'person' | 'organization'; id: string }
}

export interface SelectLinkedInTargetResponse {
  success: boolean
  targetName?: string
  targetType?: 'person' | 'organization'
}

// Thin handwritten wrappers around the new server endpoints. These can be
// replaced with `IntegrationsService.integrationControllerListLinkedInTargetsV1`
// /`...SelectLinkedInTargetV1` after running `yarn openapi` against a server
// that exposes the new routes.
export const LinkedInTargetsApi = {
  list(): Promise<LinkedInTargetsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/integrations/linkedin/targets',
    })
  },
  select(body: {
    type: 'person' | 'organization'
    id: string
  }): Promise<SelectLinkedInTargetResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/integrations/linkedin/select-target',
      body,
      mediaType: 'application/json',
    })
  },
}
